<template>
  <div class="nav-banner-message-wrapper">
    <div class="container px-md-0 px-2">
      <div class="row px-3 no-gutters nav-banner-message-container align-items-center">
        <strong>
          <font-awesome-icon class="fa-exclamation-triangle mr-1" :icon="['fa', 'exclamation-triangle']" v-if="navBannerObj.isWarning" />
          <span class="message-content" @click="trackLinkClicked" v-html="navBannerObj.text" />
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
import CONSTANTS from "@/store/constants";
export default {
  name: "NavBannerMessage",
  data() {
    return {
      navBannerObj: CONSTANTS.NAV_BANNER_MESSAGE
    }
  },
  methods: {
    trackLinkClicked(e) {
      //Extract href link from v-html to track mixpanel
      let clickEvent = e.target
      if(clickEvent.matches('.banner-external-link-white')) {
        let externalURL = clickEvent.closest("a").getAttribute('href')
        let subEvent = `URL - ${externalURL}`
        this.$hhMixpanel.trackEvent('Supplier Central - Banner external link clicked', { subEvent : subEvent });
      }
    }
  }
}
</script>

<style scoped>
.message-content >>> a {
  color: #2bc275 !important;
  text-decoration: underline;
  font-weight: 700;
}
.nav-banner-message-container {
  min-height: 50px;
  color: var(--breadcrumb-text)
}

.nav-banner-message-wrapper {
  color: var(--breadcrumb-text);
  padding-bottom: 10px;
}

</style>